import { Pipe, PipeTransform } from '@angular/core';
import { NotificationTemplate } from '../../models/enums/notification.enums';

@Pipe({
  name: 'notificationTemplate',
})
export class NotificationTemplatePipe implements PipeTransform {
  transform(notificationTemplate: NotificationTemplate): string {
    switch (notificationTemplate) {
      case NotificationTemplate.NEW_USER_MESSAGE:
        return $localize`Nouveau message`;
      case NotificationTemplate.NEW_FEEDBACK_ANSWER_FROM_WRITER:
        return $localize`Réponse à un feedback`;
      case NotificationTemplate.NEW_EXAM_ONLINE:
        return $localize`Examen en ligne`;
      case NotificationTemplate.NEW_EXAM_GROUP_RANKING_ONLINE:
        return $localize`Classement en ligne`;
      case NotificationTemplate.NEW_CORRECTION_ONLINE:
        return $localize`Correction en ligne`;
      case NotificationTemplate.NEW_RANKING_ONLINE:
        return $localize`Classement d'examen en ligne`;
      case NotificationTemplate.NEW_ARTICLE_ONLINE:
        return $localize`Article en ligne`;
      case NotificationTemplate.NEW_ITEM_ONLINE:
        return $localize`Cours en ligne`;
      case NotificationTemplate.COMMUNICATION_MARKETING:
        return $localize`Communication marketing`;
      case NotificationTemplate.CUSTOM:
        return $localize`Personnalisée`;
      case NotificationTemplate.ANCRAGE_NEW_REVISION:
        return $localize`Révisions d'ancrage disponibles`;
      case NotificationTemplate.FOLLOW_NEW_FOLLOW_REQUEST:
        return $localize`Demande d'abonnement`;
      case NotificationTemplate.FOLLOW_REQUEST_APPROVED:
        return $localize`Demande d'abonnement approuvée`;
      case NotificationTemplate.FOLLOW_NEW_FOLLOWER:
        return $localize`Nouvel abonnement`;
      case NotificationTemplate.CHALLENGE_FIRST_PLACE:
        return $localize`1ère place en challenge`;
      case NotificationTemplate.CHALLENGE_ACCEPT_INVITATION:
        return $localize`Invitation challenge acceptée`;
      case NotificationTemplate.CHALLENGE_SEND_INVITATION:
        return $localize`Invitation challenge reçue`;
      case NotificationTemplate.CHALLENGE_DECLINE_INVITATION:
        return $localize`Invitation challenge refusée`;
      case NotificationTemplate.TRANSACTION_SUCCEED:
        return $localize`Transaction réussie`;
      case NotificationTemplate.TRANSACTION_FAILED:
        return $localize`Transaction échouée`;

      default:
        return '';
    }
  }
}
